import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const query = `
  mutation (
    $easyHostTitle1: String,
    $easyHostContent1: String,
    $easyHostContent2: String,
    $workTitle1: String,
    $workTitle2: String,
    $workContent1: String,
    $workContent2: String,
    $workImage1: String,
    $workImage2: String,
    $workImage3: String,
    $dynamicWhyHostInfoBlock: String,
) {
  updateWhyHostPage (
    easyHostTitle1: $easyHostTitle1,
    easyHostContent1: $easyHostContent1,
    easyHostContent2: $easyHostContent2,
    workTitle1: $workTitle1,
    workTitle2: $workTitle2,
    workContent1: $workContent1,
    workContent2: $workContent2,
    workImage1: $workImage1,
    workImage2: $workImage2,
    workImage3: $workImage3,
    dynamicWhyHostInfoBlock: $dynamicWhyHostInfoBlock,
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: {
        easyHostTitle1: values.dynamicWhyHostInfoBlock[0].easyHostTitle1,
        easyHostContent1: values.dynamicWhyHostInfoBlock[0].easyHostContent1,
        easyHostContent2: values.dynamicWhyHostInfoBlock[0].easyHostContent2,
        workTitle1: values.dynamicWhyHostInfoBlock[0].workTitle1,
        workContent1: values.dynamicWhyHostInfoBlock[0].workContent1,
        workTitle2: values.dynamicWhyHostInfoBlock[0].workTitle2,
        workContent2: values.dynamicWhyHostInfoBlock[0].workContent2,
        workImage1: values.workImage1,
        workImage2: values.workImage2,
        workImage3: values.workImage3,
        dynamicWhyHostInfoBlock: JSON.stringify(values.dynamicWhyHostInfoBlock),
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateWhyHostPage.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
